import { useSyncExternalStore } from "react";

import { isServerReachable, subscribeToReachability } from "../../offline/connectivity";

function subscribe(callback: () => void) {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  const unsubscribe = subscribeToReachability(callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
    unsubscribe();
  };
}

// Note: online means both that the browser thinks it has a network AND that requests are actually
// getting through. navigator.onLine alone reports true for a connection that goes nowhere, which left
// the app treating a dead network as online - the banner said "Connection lost. Reconnecting" instead
// of "No internet connection", and nothing queued.
//
// getServerSnapshot returns true so SSR/first paint never flashes the offline banner before the
// browser reports its real connectivity.
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine && isServerReachable(),
    () => true
  );
}
